import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import "./ConcludePrecription.scss";
import {Col, Divider, Row, Space, Typography, Form, DatePicker} from "antd";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import PrescriptionTable from "./PrescriptionTable/PrescriptionTable";

import {Icd, Icd10} from "types/models/icd-type";
import {medicalExaminationService} from "api";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {RootState} from "redux/store";
import {Conclude} from "types/models/examination-diagnostic-type";
import {medicineStoreService} from "api";
import {EXAM_BTN_CLICK_TYPE} from "types/enums/examination";
import GlassesPrescription from "./GlassesPrescription/GlassesPrescription ";
import ConcludeIcd from "./ConcludeIcd/ConcludeIcd";
import SideDisease from "./SideDisease/SideDisease";
import TextArea from "antd/es/input/TextArea";

const {Text} = Typography;

const ConcludePrecription = React.forwardRef((props, ref) => {
  let dispatch = useAppDispatch();
  let examClick = useAppSelector(state => state.examClick);
  const [concludeForm] = Form.useForm();
  const requiredTaiKham = useAppSelector(
    state => state.examination.requiredTaiKham
  );
  const concludeRef = useRef<any>();
  const preRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    handleSave: handleSave,
  }));
  const handleSave = async () => {
    await concludeRef.current?.handleSave();
    await preRef.current?.handleSave();
  };

  // const getConcludeByExamId = async () => {
  //   if (idPKNT) {
  //     try {
  //       const response = await medicalExaminationService.getConcludeByIdExam(
  //         {
  //           idPhieuKham: idPKNT
  //         }
  //       );
  //       form.setFieldsValue({ conclude: response.data });
  //       setOptionsIcd10(response.data.map(()=>[]));
  //       try {
  //         const newOption = [];
  //         const responseIcd = await medicalExaminationService.getIcdList();
  //         response.data.map((item) => {
  //           const newOptionItem = responseIcd.data.find(
  //             (itenIcd) => itenIcd.id === item.idICD10
  //           ).listIcd10;
  //           newOption.push(newOptionItem);
  //         });
  //         setOptionsIcd10(newOption);
  //       } catch {
  //         notification.error({message: "Lỗi khi lấy danh sách ICD"});
  //       }
  //     } catch {
  //       notification.error({message: "Lấy danh sách kết luận thất bại"});
  //     }
  //   }
  // };

  useEffect(() => {
    if (examClick.actionType === EXAM_BTN_CLICK_TYPE.SAVE) {
    }
  }, [examClick]);

  return (
    <div className="container">
      <Space
        className="conclude-prescription-space"
        direction="vertical"
        size={"middle"}
      >
        <ConcludeIcd ref={concludeRef} concludeForm={concludeForm} />
        {/* <Divider />
          <SideDisease /> */}
        <Divider />
        <PrescriptionTable ref={preRef} />
        <Divider />
        <Row>
          <Form form={concludeForm}>
            <Row gutter={[0, 8]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  label={<Typography.Text ellipsis>Ghi chú</Typography.Text>}
                  name="taiKham"
                  labelAlign="left"
                  labelCol={{span: 4}}
                  wrapperCol={{span: 20}}
                >
                  <TextArea className="data-input-field" placeholder="Nhập" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  label={
                    <Typography.Text ellipsis>
                      Ngày hẹn tái khám
                    </Typography.Text>
                  }
                  rules={[
                    {
                      required: requiredTaiKham,
                      message: "Chưa nhập thông tin chẩn đoán",
                    },
                  ]}
                  name="ngayHenTaiKham"
                  labelAlign="left"
                  labelCol={{span: 4}}
                  wrapperCol={{span: 20}}
                >
                  <DatePicker
                    className="data-input-field"
                    placeholder="DD/MM/YYYY"
                    format={"DD/MM/YYYY"}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Row>
        {/* <GlassesPrescription /> */}
      </Space>
    </div>
  );
});

export default ConcludePrecription;
